import React from "react";
import {useTranslation} from "react-i18next";
import SpaceBetween from "@awsui/components-react/space-between";
import NavigationBar from "components/NavigationBar";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import FormField from "@awsui/components-react/form-field";
import Select from "@awsui/components-react/select";
import {Toggle} from "@awsui/components-react";
import {usePrefs} from "hooks/usePrefs";
import {SUPPORTED_LANGUAGES, SupportedLanguage} from "i18n";


const PrefsPage: React.FC = () => {
    const [{darkModeEnabled}, dispatch] = usePrefs();
    const {t, i18n} = useTranslation("prefs");

    const toggleDarkMode = (enabled: boolean): void => {
        dispatch({
            darkModeEnabled: enabled,
        });
    };

    const resolvedOrDefault: string = i18n.resolvedLanguage || i18n.language || "es";
    const currentLanguage: SupportedLanguage = (SUPPORTED_LANGUAGES as readonly string[]).includes(resolvedOrDefault)
        ? (resolvedOrDefault as SupportedLanguage)
        : "es";

    const languageOptions = SUPPORTED_LANGUAGES.map((code: SupportedLanguage) => ({
        label: t(`languages.${code}`),
        value: code
    }));

    return (
        <SpaceBetween size={"l"}>
            <NavigationBar/>
            <Container
                variant={"default"}
                header={
                    <Header variant={"h2"}>
                        {t("title")}
                    </Header>
                }
            >
                <SpaceBetween size="l">
                    <Toggle
                        onChange={({ detail }) => toggleDarkMode(detail.checked)}
                        checked={darkModeEnabled}
                    >
                        {t("darkMode")}
                    </Toggle>
                    <FormField label={t("language")}>
                        <Select
                            selectedOption={{
                                label: t(`languages.${currentLanguage}`),
                                value: currentLanguage
                            }}
                            onChange={({detail}) => {
                                const value = detail.selectedOption.value;
                                if (value) {
                                    i18n.changeLanguage(value);
                                }
                            }}
                            options={languageOptions}
                        />
                    </FormField>
                </SpaceBetween>
            </Container>
        </SpaceBetween>
    );
};

export default PrefsPage;
